// tslint:disable
/**
 * Notification api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { UserSettings } from '../models';
/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNotificationUserSettings.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling deleteNotificationUserSettings.');
            }
            const localVarPath = `/user/{id}/notification-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {UserSettings} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: UserSettings, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editNotificationUserSettings.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling editNotificationUserSettings.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editNotificationUserSettings.');
            }
            const localVarPath = `/user/{id}/notification-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotificationUserSettings.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling getNotificationUserSettings.');
            }
            const localVarPath = `/user/{id}/notification-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).deleteNotificationUserSettings(id, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {UserSettings} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: UserSettings, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettings> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).editNotificationUserSettings(id, type, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettings> {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).getNotificationUserSettings(id, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
            return UserApiFp(configuration).deleteNotificationUserSettings(id, type, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {UserSettings} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: UserSettings, options?: any) {
            return UserApiFp(configuration).editNotificationUserSettings(id, type, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
            return UserApiFp(configuration).getNotificationUserSettings(id, type, options)(axios, basePath);
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
        return UserApiFp(this.configuration).deleteNotificationUserSettings(id, type, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
     * @param {UserSettings} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public editNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', body: UserSettings, options?: any) {
        return UserApiFp(this.configuration).editNotificationUserSettings(id, type, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getNotificationUserSettings(id: string, type: 'newLearningRequest' | 'studentStartLearning' | 'studentFinishLearning', options?: any) {
        return UserApiFp(this.configuration).getNotificationUserSettings(id, type, options)(this.axios, this.basePath);
    }

}
